import type { AccountStatus } from '@travel-planner/shared/schemas/auth';
import { accountStatuses } from '@travel-planner/shared/schemas/auth';

export const ACCOUNT_STATUS_OPTIONS = accountStatuses.map((status) => ({
  value: status,
  label: status,
}));

export const STATUS_BADGE_VARIANT: Record<
  AccountStatus,
  'active' | 'pending' | 'inactive'
> = {
  Active: 'active',
  Invited: 'pending',
  Suspended: 'inactive',
};
